import { render, staticRenderFns } from "./taskHall.vue?vue&type=template&id=7dc45078&scoped=true&"
import script from "./taskHall.vue?vue&type=script&lang=js&"
export * from "./taskHall.vue?vue&type=script&lang=js&"
import style0 from "./taskHall.vue?vue&type=style&index=0&id=7dc45078&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc45078",
  null
  
)

export default component.exports